export const ROLE_VIEWS = {
  admin: ["today", "overview", "wellness", "book", "ai", "plan", "calendar", "settings", "users"],
  wellness: ["today", "wellness", "settings"],
  ai: ["today", "ai", "calendar"],
  book: ["today", "book"],
  pending: [],
};

export const ROLE_SECTORS = {
  admin: ["wellness", "book", "ai"],
  wellness: ["wellness"],
  ai: ["ai"],
  book: ["book"],
  pending: [],
};

export const ROLE_LABELS = {
  admin: "Amministratore",
  wellness: "Collaboratore Wellness",
  ai: "Allievo / Collaboratore AI",
  book: "Community / Lettore",
  pending: "In attesa di approvazione",
};

export const ROLE_COLORS = {
  admin: "#f1f5f9",
  wellness: "#10B981",
  ai: "#8B5CF6",
  book: "#3B82F6",
  pending: "#f59e0b",
};

export const ASSIGNABLE_ROLES = ["admin", "wellness", "ai", "book", "pending"];

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
